import { render } from "./EvalvationDepartments.vue?vue&type=template&id=cd044c06"
import script from "./EvalvationDepartments.vue?vue&type=script&lang=js"
export * from "./EvalvationDepartments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__